export default {
    common: {
        unit: 'VND',
        month:' tháng',
        confirm: 'Xác nhận',
        cancel: 'Hủy',
    },
    footer:{
        home:'Trang chủ',
        cskh:'Hỗ trợ',
        loanpage: 'Vay tiền',
        wallet: 'Ví tiền',
        account: 'Hồ sơ'
    },
    login: {
        login: 'Đăng nhập',
        register: 'Đăng ký',
        teldesc: 'Vui lòng nhập số điện thoại',
        pwddesc: 'Vui lòng nhập mật khẩu',
        codedesc: 'Vui lòng nhập mã mời',
        forget: 'Quên mật khẩu',
        noaccount: 'Bạn chưa có tài khoản?',
        toregister: 'Đăng ký ngay',
        tologin: 'Đăng nhập'
    },
    home: {
        savings:'Tiết kiệm lớn',
        rate:'Lãi suất thấp',
        disbursement:'Giải ngân nhanh',
        Congratulations:'Chúc mừng',
        withdrawn: 'giải ngân thành công',
        loanamount: 'Nhập số tiền cho vay',
        loanterm: 'Chọn vay kì hạn',
        repayment:'Trả nợ định kỳ (hàng tháng)',
        principal: 'Đã bao gồm cả gốc + lãi',
        Applyforloan:'Đăng ký vay',
        tosaveinfo: 'Vui lòng hoàn tất thông tin cá nhân và thông tin ngân hàng của bạn trước',
    },
    cskh:{
        title: 'Hỗ trợ',
        desc: 'CHĂM SÓC KHÁCH HÀNG',
        time: 'Thời gian làm việc: 08:00 đến 20:00',
        btn: 'LIÊN HỆ'
    },
    loanpage: {
        title: 'Vay tiền',
        btn:'Vay ngay'
    },
    wallet: {
        title: 'Ví tiền',
        btn: 'Rút tiền về tài khoản liên kết',
        getmoneytitle: 'Vui lòng nhập số tiền muốn rút',
        balance: 'Số dư hiện có',
        moneydesc: 'Nhập số tiền',
        codedesc: 'Nhập mật khẩu quỹ',
        empty_data:"dữ liệu trống",
        refresh:"Làm mới thành công",

       money:"SỐ TIỀN RÚT",
    desc:"LÝ DO",
        submit_time:"THỜI GIAN THỰC HIỆN",
        check_time:"THỜI GIAN XÉT DUYỆT",
    },
    account:{
        title: 'Hồ sơ',
        menu1: 'Thông tin của tôi',
        menu2: 'Khoản vay của tôi',
        menu3: 'Đổi mật khẩu',
        menu4: 'Hợp đồng',
        menu5: 'Tạo mật khẩu rút tiền',
        menu6: 'Nhận lương',
        logout: 'Đăng xuất'
    },
    contract: {
        title: 'Hỗ trợ'
    },
    changepwd:{
        title: 'Đổi mật khẩu',
        oldpwddesc: 'Vui lòng nhập mật khẩu hiện tại',
        newpwddesc: 'Vui lòng nhập mật khẩu mới',
        agepwddesc: 'Vui lòng nhập lại mật khẩu mới',
        btn: 'Đổi mật khẩu'
    },
    profile: {
        title: 'Hồ sơ cá nhân',
        msg: 'Cập nhật thông tin cá nhân của bạn',
        item1: 'Hồ sơ cá nhân',
        item2: 'Thông tin cá nhân',
        item3: 'Thông tin thẻ ngân hàng',
        item4: 'Xác nhận chữ ký',
        finish: 'Đã hoàn thành',
        tobecompleted: 'Để được hoàn thành'
    },
    bank: {
        title: 'Thông tin thẻ ngân hàng',
        msg: 'Vui lòng điền đầy đủ và chính xác thông tin để hợp đồng vay được duyệt nhanh chóng hơn',
        name: 'Tên chủ thẻ ',
        bank: 'Tên ngân hàng',
        card: 'Số tài khoản ngân hàng',
        info: 'Chú ý: Thẻ ngân hàng nhập vào phải là thẻ trả trước (debit card). Không sử dụng thẻ tín dụng (credit card).',
    },
    autograph:{
        title: 'Chữ ký viết tay',
        msg: 'Hãy ký vào ô bên dưới',
        btn1: 'Ký lại',
        btn2: 'Cập nhật thông tin',
        null: 'Chữ ký còn trống, vui lòng ký trước'
    },
    usr:{
        title: 'Thông tin cá nhân',
        msg: 'Vui lòng điền đầy đủ và chính xác thông tin để hợp đồng vay được duyệt nhanh chóng hơn',
        Phone: 'Số điện thoại',
        Education: 'Trình độ học vấn',
        Purpose: 'Mục đích vay vốn',
        House: 'Có sở hữu nhà hay không?',
        Vehicle: 'Có sở hữu phương tiện (Ô tô, xe máy) hay không?',
        Income: 'Thu nhập hàng tháng',
        Address: 'Địa chỉ hiện tại',
        Phonedesc: 'Nhập số điện thoại người thân',
        Educationdesc: 'Nhập trình độ học vấn',
        Purposedesc: 'Nhập mục đích vay vốn',
        Housedesc: 'có sở hữu nhà hay không',
        Vehicledesc: 'có sở hữu phương tiện (Ô tô, xe máy) hay không',
        Incomedesc: 'Nhập thu nhập hàng tháng',
        Addressdesc: 'Nhập địa chỉ hiện tại',
        Namedesc:'Nhập họ và tên',
        Family: 'THÔNG TIN LIÊN HỆ CỦA GIA ĐÌNH',
        Relationship:'Mối quan hệ với bạn',
        Name:'Họ và tên',
        other: 'CÁC LIÊN HỆ KHÁC',
        yes: 'Có',
        no: 'Không',
        parents:'Cha/mẹ',
        spouse:'Vợ/Chồng',
        brothers:'Anh/Chị/Em',
        classmates:'Bạn học',
        friends:'Bạn',
    },
    card: {
        title: 'Thông tin CMND/CCCD',
        msg: 'Vui lòng điền đầy đủ và chính xác thông tin để hợp đồng vay được duyệt nhanh chóng hơn',
        name: 'Họ và tên',
        cardno: 'Số CMND/CCCD',
        desc: 'Vui lòng tải lên ảnh mặt trước, sau và chân dung trên tay cầm CMND/CCCD của bạn.',
        desc1: 'Lưu ý: hình ảnh tải lên phải rõ nét và đầy đủ thông tin.',
        img1: 'Tải ảnh mặt trước CMND/CCCD',
        img2: 'Tải ảnh mặt sau CMND/CCCD',
        img3: 'Tải ảnh chụp mặt thật và trên tay cầm CMND/CCCD',
        item1: 'Tháng năm sinh',
        item2: 'Cấp CCCD'
    },
    loan: {
        title: 'Khoản vay của tôi',
        msg1: 'LƯU Ý',
        msg2: 'Bạn cần phải thanh toán trả góp khoản vay',
        msg3: 'trước ngày {day} hàng tháng',
        msg31: 'trước ngày được duyệt khoản vay',
        msg4: 'DANH SÁCH KHOẢN VAY ĐANG HIỆU LỰC',
        btn: 'Đăng ký vay tiền',
        info: 'Xem chi tiết',
        money: 'Số tiền vay',
        cycle: 'Thời gian vay',
        stime: 'Ngày bắt đầu',
        etime: 'Ngày đáo hạn',
        everyissue: ' Số tiềm trả hàng tháng',
        everyissuedesc: 'bao gồm cả gốc và lãi',
        bank: 'Ngân hàng nhận tiền',
        status: 'Trạng thái hợp đồng',

        Waiting: 'Đang chờ xác nhận',
        Loaninprogress: 'Đang tiến hành vay',
        Loanalreadymade: 'Đã thực hiện vay',
        Rejected: 'Bị từ chối'
    },
    loaninfo: {
        title: 'Số hợp đồng',
        msg: 'Thỏa thuận cho vay của bạn',
        state1: 'Đang xem xét',
        state2: 'Đã phê duyệt thành công, đang chờ thanh toán',
        state3: 'Quỹ đã được phát hành',
        notify: 'Thông báo',
        notifymsg1: 'Hợp đồng vay của bạn đang được xem xét và nhân viên hỗ trợ sẽ liên hệ với bạn sau khi hợp đồng được chấp thuận thành công.',
        notifymsg2: 'Hợp đồng vay của bạn đã được chấp thuận thành công, vui lòng đợi khoản vay được giải ngân.',
        notifymsg3: 'Khoản vay bạn đã đăng ký đã được ghi có vào tài khoản của bạn',
        thanks: 'Cảm ơn quý khách hàng thân mến!',
        code: 'Mã hợp đồng',
        money: 'Số tiền vay',
        cycle: 'Thời gian vay',
        everyissue: ' Số tiềm trả hàng tháng',
        everyissuedesc: 'bao gồm cả gốc và lãi',
        bank: 'Ngân hàng nhận tiền',
        msg1: 'Hướng dẫn trả nợ',
        msg2: 'Bạn phải trả hết số tiền vay đến hạn vào ngày {day} hàng tháng',
        btn: 'Vào "Hóa đơn của tôi" để thanh toán'
    },
    setting:{
        set_money_pwd:"Đặt mật khẩu quỹ",
        money_place:"Vui lòng nhập mật khẩu quỹ",
        money_again_place:"Vui lòng nhập lại mật khẩu quỹ",
        correct_money:"Vui lòng điền số tiền chính xác",
        prefect:"Vui lòng điền đầy đủ!",
    }
}
